import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { SpinnerVisibilityService } from 'ng-http-loader';
import Swal from 'sweetalert2'
import { BMApiService } from '../../../services/bm.service';
import { Router } from '@angular/router';
import { UserService } from '../../../services/user.service';
import {
  AngularGridInstance,
  Column,
  FieldType,
  Filters,
  Formatter,
  GridOption,
  FileType,
  Formatters,
  MenuCallbackArgs,

} from 'angular-slickgrid';

import { NgxSelectModule } from 'ngx-select-ex';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { UtilityService } from '../../../services/utility.service';
import { tranbenchmarkkpi, tranbenchmarkkpihistory, kpiViewComment, year } from '../../../models/slakpi';
import { division } from '../../../models/admin';
import { ToasterService } from '../../../toaster.service';
import { SLAKPIApiService } from '../../../services/slakpi.service';
import * as XLSX from 'xlsx';
@Component({
  selector: 'app-bench-mark-database',
  templateUrl: './bench-mark-database.component.html',
  styleUrls: ['./bench-mark-database.component.css']
})
export class BenchMarkDatabaseComponent implements OnInit {
  public commentStartIndex: number = 1;
  public commentMaxCount: number = 100;
  disableMore: boolean = true;
  isStart: boolean = true;
  public KPIdata: any;
  public kpiViewComment_data: any;
  public isRejectError: boolean = false;
  public txtRejectError: string = '';
  searchText: string = '';
  public rejectComment: string = '';
  @ViewChild('ReminderDialog', { static: false }) ReminderDialog: TemplateRef<any>;
  @ViewChild('CommentDialog', { static: false }) CommentDialog: TemplateRef<any>;
  public benchMarkYear_data: any;
  public currentHalf_data: any;
  public division_data: any;
  public gridApi: any;
  public gridColumnApi: any;
  public columnDefs: any;
  public defaultColDef: any;
  public rowData: any;
  public PopoverModule;
  modalRef: BsModalRef;
  columnDefinitions: Column[];
  gridOptions: GridOption;
  dataset: any;
  yearfilter: any=0;
  divisionUnofilter: any=0;
  halffilter: any;
  angularGrid: AngularGridInstance;
  public TranKPI_data: any;
  public loading: boolean = true;
  public pageAction: string = 'add';
  public filterDataCollectionCount: number = 0;
  public filterOverdueCount: number = 0;
  public filterCompletedCount: number = 0;
  public filterApprovalCount: number = 0;
  columnCommentDefinitions: Column[];
  cmtsGrid: AngularGridInstance;
  datasetComments: any;
  fullDataset: any = [];
  public filterAll_classactive: string = '';
  public filterDataCollection_classactive: string = 'active';
  public filterOverdue_classactive: string = '';
  public filterCompleted_classactive: string = '';
  public filterApproval_classactive: string = '';
  public tranBenchMarkKPIHistory_data: any;

  objTranBenchmarkKPI: any = new tranbenchmarkkpi();
  //for Users Default Value
  user: any = {};
  login_UserID: string; // number
  isAdmin: boolean;
  statusUno: number = 1;
  kpinameSelected: string;
  public isBMChampion: boolean = false;
  public isBMTeam: boolean = false;
  public isBMVisitor: boolean = false;
  public isBMAdmin: boolean = false;
  noDataImg: any;
  tenantUno: any;
  yearData: any;
  tranBenchmarkKPIExportList: any[];
  constructor(public restApiBM: BMApiService, private toaster: ToasterService, public utilityService: UtilityService, private router: Router, private spinner: SpinnerVisibilityService, private userService: UserService, private modalService: BsModalService, public restSLAKPIApi: SLAKPIApiService) {
    this.user = this.userService.getUserInfo();
    this.login_UserID = this.user.id;
    this.noDataImg = this.utilityService.getnodataImage();
    this.tenantUno = this.user.tenantUno;
    this.ValidateUserAccess();

  }
  ValidateUserAccess() {
    

    this.isAdmin = (this.user.role == 'Administrator' || this.user.role == 'BM Administrator') ? true : false;

    if (this.user.role == 'BM Champions')
      this.isBMChampion = true;
    if (this.user.role == 'BM Team')
      this.isBMTeam = true;
    if (this.user.role == 'BM Visitor')
      this.isBMVisitor = true;
    if (this.user.role == 'BM Administrator') { this.isBMAdmin = true; }

    if (!this.isAdmin) {
      let userPermissionData = this.userService.getUserRights("Performance BM Tracking sheet");
      if (userPermissionData != null && userPermissionData != undefined && userPermissionData.length > 0) {
        if (userPermissionData[0].showPage == 1) {

        }
        else {
          this.router.navigateByUrl('/access-denied');
        }
      }
    }

  }
  ngOnInit() {
    this.userService.CheckLogin();
    this.user = this.userService.getUserInfo();
    this.yearfilter = Number(this.user.currentYear);
    this.halffilter = Number(this.user.currentHalf);
    this.login_UserID = this.user.id;
    this.isAdmin = (this.user.role == 'Administrator') ? true : false;

    this.gridOptions = {
      autoHeight: true,
      enableAutoResize: true,
      enablePagination: true,
      pagination: {
        pageSizes: [5, 10, 20, 50, 100, 500],
        pageSize: 20
      },
      enableFiltering: true,
      alwaysShowVerticalScroll: false,
      enableRowSelection: true,
      autoResize: {
        containerId: 'musherat-grid',
        delay: 0,
        sidePadding: 10,
        bottomPadding: 10
      },
      enableExcelExport: true,
      enableExcelCopyBuffer: true,
      enableFilterTrimWhiteSpace: true,
      showCustomFooter: true, // display some metrics in the bottom custom footer
      enableContextMenu: true,
      enableCellMenu: true,
      forceFitColumns: true,

    };
    this.loadYear();
    //this.getBenchMarkYear();
    this.getDivisions();
    this.getcurrentHalf();
    this.LoadTranBenchmarkKPI();
  }

  angularGridReady(angularGrid: AngularGridInstance) {
    this.angularGrid = angularGrid;
    this.userService.angularGrid = angularGrid;
  }

  searchGrid() {
    if (this.searchText != "") {
      this.dataset = this.fullDataset.filter(ticket =>
        ticket.kpiNameEn.toLowerCase().includes(this.searchText.toLowerCase())
        || (ticket.kpiCode && ticket.kpiCode.toLowerCase().includes(this.searchText.toLowerCase()))
        || (ticket.dataOwnerName && ticket.dataOwnerName.toLowerCase().includes(this.searchText.toLowerCase()))
        || (ticket.targetValue && ticket.targetValue.toLowerCase().includes(this.searchText.toLowerCase()))
        || (ticket.status && ticket.status.toLowerCase().includes(this.searchText.toLowerCase()))
        || (ticket.formula && ticket.formula.toLowerCase().includes(this.searchText.toLowerCase())));
    }
    else
      this.dataset = this.fullDataset;
  }

  getBenchMarkYear() {
    
    let date = new Date();
    let pastYear = date.getFullYear() - 1;
    let currentYear = date.getFullYear();
    let futureYear = date.getFullYear() + 1;

    this.benchMarkYear_data = [
      { text: pastYear, value: pastYear },
      { text: currentYear, value: currentYear },
      { text: futureYear, value: futureYear }
    ];
  }
  loadYear() {

    let inpValue = new year();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 0;
    inpValue.tenantUno = this.tenantUno;
    inpValue.userUno = this.login_UserID;
    
    this.restSLAKPIApi.getYearMaster(inpValue)
      .subscribe(data => {
        
        this.yearData = data;

      },
        (error) => {
          //Called when error

        }
      ).add(() => {
        //Called when operation is complete (both success and error)

      });
  }
  getcurrentHalf() {
    

    this.currentHalf_data = [
      { text: 'First Half', value: 1 },
      { text: 'Second Half', value: 2 }
    ];
  }

  getDivisions() {

    let inpValue = new division();
    inpValue.userUno = this.login_UserID;
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 5;
    inpValue.tenantUno = this.tenantUno;
    this.restApiBM.getDivisions(inpValue)
      .subscribe(data => {
        this.division_data = data;
      },
        (error) => {
          //Called when error
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
      });
  }
  searchKPIRelease() {
    
    let temp = this;
    this.spinner.show();
    if (!this.isStart) {
      setTimeout(function () { temp.LoadTranBenchmarkKPI(); }, 1000)

    }

  }



  LoadTranBenchmarkKPI() {
    
    this.spinner.show();
    this.loading = true;
    let currentYear = new Date().getFullYear();
    this.yearfilter = this.yearfilter ? this.yearfilter : currentYear;
    this.halffilter = this.halffilter ? this.halffilter : 1;

    let inpValue = new tranbenchmarkkpi();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 5;
    inpValue.userUno = this.login_UserID;
    inpValue.statusUno = 5;
    inpValue.benchmarkYear = this.yearfilter ? this.yearfilter : 0;
    inpValue.kpiType = (this.halffilter == 1) ? 2 : 4;//this.halffilter;
    inpValue.tenantUno = this.tenantUno;
    inpValue.divisionUno = this.divisionUnofilter?this.divisionUnofilter : 0;
    this.restApiBM.getTranBenchMarkKPIs(inpValue)
      .subscribe((data: any) => {
        
        let rtn_data = data;
        const mockDataset = [];
        this.dataset = [];
        if (rtn_data != null && rtn_data.length > 0) {

          //uniqBy(data, 'kpiUno');

          for (let i = 0; i < rtn_data.length; i++) {

            let status = '';
            if (rtn_data[i].statusUno == '0')
              status = 'Released';
            else if (rtn_data[i].statusUno == '1')
              status = 'Data Entry';
            else if (rtn_data[i].statusUno == '2')
              status = 'Approval 1';
            else if (rtn_data[i].statusUno == '3')
              status = 'Approval 2';
            else if (rtn_data[i].statusUno == '4')
              status = 'Approval 3';
            else if (rtn_data[i].statusUno == '5')
              status = 'Completed';



            mockDataset[i] = {
              id: rtn_data[i].trnBenchmarkUno,
              kpiCode: rtn_data[i].kpiCode,
              kpiUno: rtn_data[i].kpiUno,
              kpiNameEn: rtn_data[i].kpiNameEn,
              dataOwnerName: rtn_data[i].dataOwnerName,
              dataOwnerUno: rtn_data[i].dataOwnerUno,
              level1ApproverUno: rtn_data[i].level1ApproverUno,
              level2ApproverUno: rtn_data[i].level2ApproverUno,
              level3ApproverUno: rtn_data[i].level3ApproverUno,

              level1Approver: rtn_data[i].level1Approver,
              level2Approver: rtn_data[i].level2Approver,
              level3Approver: rtn_data[i].level3Approver,
              targetValue: rtn_data[i].targetValue,
              actualValue: (rtn_data[i].actualValue == '') ? '-' : rtn_data[i].actualValue,
              kpiRule: rtn_data[i].kpiRule,
              rowType: rtn_data[i].rowType,
              isRelease: rtn_data[i].isRelease,
              statusUno: rtn_data[i].statusUno,
              formula: rtn_data[i].formula,
              status: status
            };
          }
          this.fullDataset = mockDataset;
          this.dataset = mockDataset;
          if (mockDataset.length > 0) {
            this.setColnDefn();
          }
          this.TranKPI_data = rtn_data;
          
        }
        else {
          this.dataset = [];
         
          
        }
        if (this.dataset.length > 0) {
          this.getTranBenchmarkKPI_Export();
        }
        this.isStart = false;
        this.loading = false;
        this.spinner.hide();
      },
        (error) => {
          //Called when error
          this.loading = false;
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.loading = false;
        this.spinner.hide()
      });
  }



  onSubmitReminder() {
    let comment = this.rejectComment;

    if (comment == '' || comment == null) {
      //Swal.fire('Error', 'Please Enter Comment', 'error')     
      this.txtRejectError = 'Please Enter Comment';
      this.isRejectError = true;
      return false;
    } else {
      this.modalRef.hide();
      this.txtRejectError = '';
      this.isRejectError = false;
      Swal.fire({
        title: '',
        text: 'Please confirm to send the reminder',
        type: 'info',
        showCancelButton: true,
        confirmButtonText: 'Ok',
        cancelButtonText: 'Cancel'
      }).then((result) => {
        if (result.value) {
          let inpValue = this.TranKPI_data.filter(e => e.trnBenchmarkUno == this.KPIdata.id)[0];
          inpValue.tenantUno = 1;
          inpValue.userUno = this.login_UserID;
          inpValue.comments = comment;

          this.restApiBM.sendBenchmarkReminderKPI(inpValue)
            .subscribe(data => {

              if (data != null && data != undefined && data != '') {
               // Swal.fire('Error', 'Something went wrong', 'error')
                this.toaster.show('error', 'Error', 'Something went wrong.');
              }
              else {
                this.toaster.show('success', 'Success', 'Reminder sent.');
                //Swal.fire({
                //  type: 'success',
                //  title: 'Reminder sent',
                //  showConfirmButton: false,
                //  timer: 1500
                //})
                this.txtRejectError = '';
                this.isRejectError = false;
                // this.loadSlaKpiDatabase(2); //by filter
              }


              this.spinner.hide();
            },
              (error) => {
                //Called when error
                this.spinner.hide();
              }
            ).add(() => {
              //Called when operation is complete (both success and error)
              this.spinner.hide();
            });

          return;
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          this.txtRejectError = '';
          this.isRejectError = false;
          return;
        }
      })
    }
    return true;
  }

  reminderKPI(KPIdata1: any) {
    this.KPIdata = KPIdata1;
    this.kpinameSelected = KPIdata1.kpiCode + ' : ' + KPIdata1.kpiNameEn;
    this.rejectComment = '';
    this.txtRejectError = '';
    this.isRejectError = false;
    this.modalRef = this.modalService.show(
      this.ReminderDialog,
      Object.assign({}, {
        class: 'gray modal-lg modal-medium',
        backdrop: true,
        keyboard: true,
        focus: true,
        show: false,
        ignoreBackdropClick: true,
        animated: true
      })
    );
  }

  showCommentDialog(kpiTrnUno: any, kpiCode: any, kpiName: any) {
    this.kpiViewComment_data = [];
    this.commentStartIndex = 1;
    this.kpinameSelected = kpiCode + ' : ' + kpiName;
    this.viewKPIComment(kpiTrnUno);
    this.modalRef = this.modalService.show(
      this.CommentDialog,
      Object.assign({}, {
        class: 'gray modal-s',
        backdrop: true,
        keyboard: true,
        focus: true,
        show: false,
        ignoreBackdropClick: true,
        animated: true
      })
    );



  }
  viewKPIComment(kpiTrnUno: any) {
    
    this.spinner.show();
    let inpValue = new kpiViewComment();
    inpValue.kpiTrnUno = kpiTrnUno;
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 5;
    inpValue.tenantUno = 1;
    inpValue.userUno = this.login_UserID;
    this.commentStartIndex = (this.commentStartIndex == undefined || this.commentStartIndex < 1) ? 1 : this.commentStartIndex;
    inpValue.startIndex = this.commentStartIndex;
    inpValue.maxCount = this.commentMaxCount;

    this.restApiBM.getKpiReminderComments(inpValue)
      .subscribe(data => {

        let objData: any = data;
        if (this.commentStartIndex == 1) {
          this.kpiViewComment_data = [];
          this.kpiViewComment_data = objData;
        }
        else {
          for (var i = 0; i < objData.length; i++) {
            this.kpiViewComment_data.push(objData[i]);
          }
        }

        const mockDataset = [];
        for (let i = 0; i < this.kpiViewComment_data.length; i++) {
          mockDataset[i] = {
            id: i + 1,
            action: 'Reminder Sent',
            postedBy: this.kpiViewComment_data[i].postedBy,
            postedDate: this.kpiViewComment_data[i].postedDate,
            comment: this.kpiViewComment_data[i].comment,
          };
        }
        this.datasetComments = mockDataset;
        this.setCommentDefn();
        //if the result set is lessthen 10 then disable the load more icon
        this.disableMore = (objData.length >= 5) ? false : true;
        if (objData.length > 0) {
          //this.ifcountgreaterthanzero = true;
          this.commentStartIndex = this.commentStartIndex + 1;
        }

        this.spinner.hide();
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });
  }
  cmtsGridReady(angularGrid: AngularGridInstance) {
    this.cmtsGrid = angularGrid;
  }

  exportToExcelCmt() {
    var temp = this;
    setTimeout(function () {
      temp.cmtsGrid.excelExportService.exportToExcel({
        filename: 'Export',
        format: FileType.xlsx,

      });
    }, 100)


  }

  setCommentDefn() {
    this.columnCommentDefinitions = [
      { id: 'action', name: 'Action', field: 'action', sortable: true },
      { id: 'postedBy', name: 'Action By', field: 'postedBy', sortable: true },
      { id: 'postedDate', name: 'Date', field: 'postedDate', sortable: true },
      { id: 'comment', name: 'Comment', field: 'comment', sortable: true },

    ];
  }



  setColnDefn() {
    let temp = this;
    this.columnDefinitions = [
      {
        id: 'kpiCode', name: 'KPI Code', field: 'kpiCode', sortable: true,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'kpiCode', 'kpiCode'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'kpiNameEn', name: 'KPI Name', field: 'kpiNameEn', sortable: true, width: 300,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'kpiNameEn', 'kpiNameEn'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'dataOwnerName', name: 'Owner', field: 'dataOwnerName', sortable: true,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'dataOwnerName', 'dataOwnerName'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'actualValue', name: 'Actual', field: 'actualValue', sortable: true, width: 50,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'actualValue', 'actualValue'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'targetValue', name: 'Target', field: 'targetValue', sortable: true, width: 50,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'targetValue', 'targetValue'),
          model: Filters.multipleSelect,
        }
      },
      //{
      //  id: 'formula', name: 'KPI Rule', field: 'formula', sortable: true, toolTip: 'formula',
      //  type: FieldType.string, filterable: true,
      //  formatter: (row, cell, val, columnDef, data) => {
      //    return data.formula.length > 40 ? data.formula.substring(0, 40) + '..' : data.formula;
      //  },
      //  filter: {
      //    collection: this.uniqueArray(this.dataset, 'formula', 'formula'),
      //    model: Filters.multipleSelect,
      //  }
      //},

      {
        id: 'status', name: 'Status', field: 'status', sortable: true, width: 50,
        type: FieldType.string, filterable: true,
        formatter: (row, cell, val, columnDef, data) => {
          if (data.statusUno == '0' || data.statusUno == '1')
            return '<span  class="status-area status-red">Data Entry</span>';
          else if (data.statusUno == '2')
            return '<span  class="status-area status-orange">Approval 1</span>';
          else if (data.statusUno == '3')
            return '<span  class="status-area status-yellow">Approval 2</span>';
          else if (data.statusUno == '4')
            return '<span  class="status-area status-light-green">Approval 3</span>';
          else if (data.statusUno == '5')
            return '<span  class="status-area status-green">Completed</span>';
        },
        filter: {
          collection: this.uniqueArray(this.dataset, 'status', 'status'),
          model: Filters.multipleSelect,
        }
      },

      {
        id: 'action', name: 'Action', field: 'action', cssClass: 'blue', width: 50,
        excludeFromExport: true,
        formatter: this.actionFormatter,
        cellMenu: {
          hideCloseButton: false,
          commandTitleKey: 'COMMANDS',
          commandItems: [
            {
              command: 'Release-row', titleKey: 'Release_ROW', positionOrder: 62, title: 'Send Reminder',
              itemVisibilityOverride: (args: MenuCallbackArgs) => {
                let data = args.dataContext;
              

                if (data.statusUno != '5' && (this.isAdmin || this.isBMTeam || this.isBMAdmin))
                  return true;
                else return false;
              },
              iconCssClass: 'fa fa-send-o fa-lg ', cssClass: 'blue ', textCssClass: 'bold',
              action: (e, args) => {
                this.reminderKPI(args.dataContext)

              }
            },

            {
              command: 'Target-row', titleKey: 'Target_ROW', positionOrder: 63, title: 'Pending with',
              iconCssClass: 'fa fa-user-circle fa-lg orange-text ', cssClass: 'orange-text', textCssClass: 'bold',
              itemVisibilityOverride: (args: MenuCallbackArgs) => {
                let data = args.dataContext;
                if (data.statusUno != '5' && this.isAdmin && this.isBMTeam && this.isBMAdmin)
                  return true;
                else return false;
              },
              action: (e, args) => {
                let data = args.dataContext;
                let userName = '';
                if (data.statusUno == '0' || data.statusUno == '1')
                  userName = data.dataOwnerName;
                else if (data.statusUno == '2')
                  userName = data.level1Approver;
                else if (data.statusUno == '3')
                  userName = data.level2Approver;
                else if (data.statusUno == '4')
                  userName = data.level3Approver;

                Swal.fire({
                  title: '',
                  html: 'KPI is pending with: <br><b>' + userName + '</b><br/>',
                  type: 'info',
                  showCancelButton: true,
                  confirmButtonText: 'Ok',
                  cancelButtonText: 'Cancel'
                }).then((result) => {
                  if (result.value) {
                    return;
                  } else if (result.dismiss === Swal.DismissReason.cancel) {

                    return;
                  }
                })
              }
            },
            {
              command: 'Band-row', titleKey: 'Band_ROW', positionOrder: 64, title: 'View Reminder Log',
              iconCssClass: 'fa fa-comment green-text fa-lg ', cssClass: 'green-text', textCssClass: 'bold green-text',

              action: (e, args) => {
                let data = args.dataContext;
                this.showCommentDialog(data.id, data.kpiCode, data.kpiNameEn);
              }
            },



            {
              command: 'info-row', titleKey: 'info_ROW', positionOrder: 67, title: 'KPI Info',
              iconCssClass: 'fa fa-lg fa-info-circle  ', cssClass: 'blue', textCssClass: 'bold',
              action: (e, args) => {
                let data = args.dataContext;
                
                this.router.navigateByUrl('/benchmarkkpiinfo/' + data.kpiUno);
              },

            },


            {
              command: 'delete-row', titleKey: 'DELETE_ROW', positionOrder: 69, title: 'Delete',
              itemVisibilityOverride: (args: MenuCallbackArgs) => {
                let data = args.dataContext;

                if (this.isBMVisitor)
                  return false;
                else return true;
              },
              iconCssClass: 'fa fa-trash', cssClass: 'red', textCssClass: 'bold',
              action: (e, args) => {
                Swal.fire({
                  title: 'Delete',
                  text: 'Please confirm to delete the record',
                  type: 'warning',
                  showCancelButton: true,
                  confirmButtonText: 'Ok',
                  cancelButtonText: 'Cancel'
                }).then((result) => {
                  if (result.value) {
                    this.pageAction = 'delete';
                    this.deleteTranBenchMarkKPI_Inbox(args.dataContext);
                  } else if (result.dismiss === Swal.DismissReason.cancel) {

                  }
                })
              }
            },

          ],
        }
      }




    ]


  }
  onDbClicked(ev, es) {
    

    let rdata = this.angularGrid.gridService.getDataItemByRowIndex(es.row)


    if (rdata != null && rdata != undefined) {
      this.router.navigateByUrl('/benchmarkkpiview/' + rdata.id);
    }
    return false;
  }


  getViewHistory(id: number) {
    

    let inpValue = new tranbenchmarkkpihistory();

    inpValue.itemUno = id;
    inpValue.condition = 1;
    inpValue.userUno = this.login_UserID;
    this.restApiBM.getTranBenchMarkKPIHistory(inpValue)
      .subscribe(data => {
        
        this.tranBenchMarkKPIHistory_data = data;
      },
        (error) => {
          //Called when error
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
      });

  }

  onSendApproval(val1, type) {
    
    if (!val1) {
      // Swal.fire('Error', 'Please enter the required information.', 'error');
      this.toaster.show('warning', 'Warning', 'Please enter the required information.');
      return;
    }
    else {
      this.ApproveProcessBenchMarkEntry(this.objTranBenchmarkKPI, type)
    }
  }

  onfilterData(type: any) {
    if (type == 'data')
      this.statusUno = 1;
    if (type == 'approval')
      this.statusUno = 2;
    if (type == 'completed')
      this.statusUno = 5;

    this.filterDataCollection_classactive = (type == 'data') ? 'active' : '';
    this.filterApproval_classactive = (type == 'approval') ? 'active' : '';
    this.filterCompleted_classactive = (type == 'completed') ? 'active' : '';


    this.LoadTranBenchmarkKPI();
  }

  onApproveBenchMarkEntry(val1, type) {
    
    if (!val1) {
      // Swal.fire('Error', 'Please enter the required information.', 'error');
      this.toaster.show('warning', 'Warning', 'Please enter the required information.');
      return
    }
    else {
      this.ApproveProcessBenchMarkEntry(this.objTranBenchmarkKPI, type)
    }
  }
  ApproveProcessBenchMarkEntry(data1: any, type: any) {
    
    let message = ''
    this.objTranBenchmarkKPI.userUno = 1;
    if (type == 'save') {
      this.objTranBenchmarkKPI.condition = 0;
      message = 'Data Entry saved.';
    }
    else if (type == 'send') {
      this.objTranBenchmarkKPI.condition = 1;
      message = 'Sent for approval.';
    }
    else if (type == 'approve') {
      this.objTranBenchmarkKPI.condition = 2;
      message = 'Approved Successfully.';
    }
    else if (type == 'reject') {
      this.objTranBenchmarkKPI.condition = 3;
      message = 'Rejected Successfully.';
    }
    this.objTranBenchmarkKPI.userUno = this.login_UserID;
    this.restApiBM.addEditTranBenchMarkKPI_Inbox(this.objTranBenchmarkKPI)
      .subscribe(data => {

        if (data != null && data != undefined && data != '') {
          // Swal.fire('Error', 'Something went wrong', 'error');
          this.toaster.show('error', 'Error', 'Something went wrong');
          this.spinner.hide();
        }
        else {
          //Swal.fire({
          //  type: 'success',
          //  title: message,
          //  showConfirmButton: false,
          //  timer: 1500
          //})
          this.toaster.show('success', 'Success', message);
          this.modalRef.hide();
          setTimeout(() => {
            this.spinner.hide();
            this.LoadTranBenchmarkKPI();
          }, 900);

        }



      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        //this.spinner.hide();
      });
    return true;

  }
  actionFormatter: Formatter = (row, cell, value, columnDef, dataContext) => {
    return `<div class="fake-hyperlink"> <i class="fa fa-ellipsis-h fa-lg"></i></div>`;
  };
  uniqueArray(arrayList, val, label) {
    var temp = this;
    var aList = [];
    if (arrayList) {
      for (var i = 0, l = arrayList.length; i < l; i++)
        if (aList.filter(item => item.label == temp.Checklabel(arrayList[i][label])).length == 0) {

          aList.push({
            'value': this.CheckValue(arrayList[i][val]), 'label': this.Checklabel(arrayList[i][label])
          });
        }
    }


    aList.sort((a: any, b: any) => {
      if (a['value'] < b['value']) {
        return -1;
      } else if (a['value'] > b['value']) {
        return 1;
      } else {
        return 0;
      }
    });
    return aList;
  }

  Checklabel(val) {
    if (val != undefined && val != null && val != '' && val != ' ')
      return val;
    else
      return ''

  }

  CheckValue(val) {
    if (val != undefined && val != null && val != '' && val != ':')
      return val;
    else
      return ' '

  }

  IsNull(val) {
    if (val != undefined && val != null && val != '') {
      val = val.trim()
      return val.charAt(0).toUpperCase() + val.slice(1);
    }
    else
      return ' '

  }
getTranBenchmarkKPI_Export() {
    
    
    this.loading = true;
    let currentYear = new Date().getFullYear();
    this.yearfilter = this.yearfilter ? this.yearfilter : currentYear;
    this.halffilter = this.halffilter ? this.halffilter : 1;

    let inpValue = new tranbenchmarkkpi();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 5;
    inpValue.userUno = this.login_UserID;
    inpValue.statusUno = 5;
    inpValue.benchmarkYear = this.yearfilter ? this.yearfilter : 0;
    inpValue.kpiType = (this.halffilter == 1) ? 2 : 4;//this.halffilter;
    inpValue.tenantUno = this.tenantUno;
    inpValue.divisionUno = this.divisionUnofilter ? this.divisionUnofilter : 0;
    this.restApiBM.getTranBenchMarkKPIs_Export(inpValue)
      .subscribe((data: any) => {
        
        if (data != null) {
          this.tranBenchmarkKPIExportList = data;
        } else {
          this.tranBenchmarkKPIExportList = [];
        }
       
      },
        (error) => {
          //Called when error
          this.tranBenchmarkKPIExportList = [];
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        
      });
  }
  exportExcel() {
    if (this.tranBenchmarkKPIExportList.length > 0) {
      let items = [];
      const wb = { SheetNames: [], Sheets: {} };
      let filename = 'master.xlsx';


      for (var i = 0; i < this.tranBenchmarkKPIExportList.length; i++) {
        items.push({
          ID: i + 1,
          Division: this.tranBenchmarkKPIExportList[i].divisionName,
          KPINameEn: this.tranBenchmarkKPIExportList[i].kpiNameEn,
          Year: this.tranBenchmarkKPIExportList[i].benchmarkYear,
          Actual: this.tranBenchmarkKPIExportList[i].trnActualValue,
          Target: this.tranBenchmarkKPIExportList[i].trnTargetValue,
          
          //Source: this.tranBenchmarkKPIExportList[i].sourceName,
          //Peers: this.tranBenchmarkKPIExportList[i].peerName,
          //Considered_benchmarks: this.tranBenchmarkKPIExportList[i].considerationName,
          //Filter: this.tranBenchmarkKPIExportList[i].filter,
          //Constraints: this.tranBenchmarkKPIExportList[i].targetValue,
          //BechmarkEntryActual: this.tranBenchmarkKPIExportList[i].actualValue
        });
      }
      filename = 'TransactionBenchmarkKPI.xlsx'
      var ws = XLSX.utils.json_to_sheet(items);
      wb.SheetNames.push("BenchmarkKPI"); wb.Sheets["BenchmarkKPI"] = ws;

      const excelBuffer: any = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
      const dataVal: Blob = new Blob([excelBuffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
      });
      if (window.navigator.msSaveOrOpenBlob) //IE & Edge
      {
        //msSaveBlob only available for IE & Edge
        window.navigator.msSaveBlob(dataVal, filename);
      }
      else //Chrome & FF
      {
        var url = window.URL.createObjectURL(dataVal);
        var a = document.createElement('a');
        document.body.appendChild(a);
        a.setAttribute('style', 'display: none');
        a.href = url;
        a.download = filename;
        a.click();
        window.URL.revokeObjectURL(url);
        a.remove(); // remove the element
      }

    }
  }
  deleteTranBenchMarkKPI_Inbox(data1: any) {
    


    
    this.objTranBenchmarkKPI.condition = 12;
    this.objTranBenchmarkKPI.trnBenchmarkUno = data1.id;
    this.objTranBenchmarkKPI.userUno = this.login_UserID;
    this.restApiBM.addEditTranBenchMarkKPI_Inbox(this.objTranBenchmarkKPI)
      .subscribe(data => {
        
        if (data != null && data != undefined && data != '') {
          // Swal.fire('Error', 'Something went wrong', 'error');
          this.toaster.show('error', 'Error', 'Something went wrong');
          this.spinner.hide();
        }
        else {



          this.toaster.show('success', 'Success', 'Successfully deleted');
          // this.modalRef.hide();
          setTimeout(() => { this.spinner.hide(); this.loading = true; this.LoadTranBenchmarkKPI(); }, 900);


        }



      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        //this.spinner.hide();
      });
  }
}
